import * as React from "react";
import PropTypes from "prop-types";
import { Tabs as MuiTabs, Tab, Box } from "@mui/material";

function TabPanel(props) {
  const { children, value, index = true, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <span>{children}</span>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Tabs(props) {
  const {
    header = [],
    active = 0,
    className,
    renderMenu,
    children,
    onChange,
    ...other
  } = props;
  const [value, setValue] = React.useState(0);
  const [tabsOrientation, setTabsOrientation] = React.useState("horizontal");

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setValue(active || 0);
    }, 300);

    return () => clearTimeout(timer);
  }, [active]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < 576
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        className={`flex flex-col  md:flex-row justify-between gap-4 w-full mb-[20px] rounded-[12px] ${className}`}
        {...other}
      >
        <MuiTabs
          value={value}
          onChange={handleChange}
          // orientation={tabsOrientation}
          variant="scrollable"
          scrollButtons={true}
          allowScrollButtonsMobile
          className="order-2 md:order-1 shadow-xs border !border-gray-100 !rounded-[16px] w-full"
          sx={{
            "& .MuiTabs-scrollButtons.Mui-disabled": {
              width: 0,
              opacity: 0,
              display: "none",
            },
            "& .MuiTabs-scrollButtons": {
              transition: "width 0.3s, opacity 0.3s",
              width: "22px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              "& svg": {
                fontSize: "1.50rem",
              },
            },
          }}
        >
          {header.map((item, i) => (
            <Tab
              onClick={() => onChange && onChange(item.id)}
              key={i}
              icon={item.icon}
              label={item.label}
              {...a11yProps(i)}
            />
          ))}
        </MuiTabs>

        {renderMenu && <div className="order-1 md:order-2">{renderMenu()}</div>}
      </Box>
      <div>
        {children.length > 0 &&
          children.map((el, i) => (
            <TabPanel key={i} value={value} index={i}>
              <div>{el}</div>
            </TabPanel>
          ))}
      </div>
    </Box>
  );
}
